<script setup lang="ts">
import type { FrontContent } from "@gasparigit/omnia-sdk";
import { DateFormatter } from "@internationalized/date";
import Notice from "~/components/icons/Notice.vue";
import { processError } from "~/lib/utils/errors";
import { defineSeo } from "~/lib/utils/seo";

const omniaSdk = useOmniaSdk();
const memowebId = useParamId();

const { data, error } = await useAsyncData(`memoweb-${memowebId}`, async () => {
  try {
    return await omniaSdk.v1.memowebs.get(memowebId);
  } catch (error) {
    processError(error);
  }
});

if (error.value) processError(error.value);

defineSeo(data.value);

const df = new DateFormatter("it-IT", { dateStyle: "long" });
</script>

<template>
  <FrontBreadcrumHero :breadcrumbs="[{ title: 'Memoweb', href: '/memoweb' }, { title: data?.title }]" :title="data?.title" :back-url="'/memoweb'" />

  <Skeleton v-if="!data" class="main-content w-full h-52 rounded-lg" />
  <div class="main-content" v-else>
    <div class="lg:grid grid-cols-8 gap-10 xl:gap-20">
      <div class="col-start-2 col-span-6 mb-16 lg:mb-0">
        <div class="md:flex items-end justify-between mb-4">
          <div class="mb-3 md:mb-0">
            <div class="info-label">Memoweb</div>
            <p class="info-number mt-3">{{ df.format(data.date || data.published_at || data.created_at) }}</p>
          </div>
        </div>

        <!-- TITOLO -->
        <h2 class="text-4xl font-extrabold mt-5">{{ data.title }}</h2>

        <div class="mb-8">
          <div class="mt-5">
            <FrontContentBodyWithFiles :text="data.body" />
          </div>

          <template v-if="data.memocast?.file">
            <h3 class="text-2xl font-bold mt-5">Ascolta il Memocast di oggi!</h3>
            <p class="text-themeGray text-base mt-2 mb-4">Il podcast che riassume, in pochi minuti, le principali notizie dedicate alla PA contenute nel Memoweb di oggi.</p>
            <FrontAudioPlayer :file="data.memocast.file" />
          </template>

          <div class="flex flex-col gap-y-6 mt-10 mb-16 md:ms-5 ps-5 border-s-2 border-primary">
            <template v-for="content in data.contents">
              <FrontContentItem :content="(content as FrontContent)" :link-config="{ memoweb: data }" />
            </template>
          </div>
          <FrontUnauthorized v-if="!data.allowed" :link-config="{ memoweb: data }" />
        </div>
      </div>
    </div>
  </div>

  <AdminLinkToAdmin :config="{ memoweb: data }" />
</template>
